<template>
  <ButtonComponent
    id="request_linkedin_login"
      :variant="$props.variant"
      :text="$props.text"
      :image="'https://cdn.systemico.net/abc/icons/linkedin.svg'"
      @click="loginWithGoogle()"
      class="text-center">
    <img
        src="../../../../assets/images/logo__google.svg"
        alt="logotipo google"
      />
  </ButtonComponent>
  <!--../../../../assets/images/logo__google.svg-->
</template>
<script>
import ButtonComponent from './ButtonComponent.vue'
export default {
  name: 'ButtonLinkedInLogin',
  components: {
    ButtonComponent
  },
  props: {
    text: String,
    variant: String
  },
  methods: {
    loginWithGoogle () {
      const backendUrl = process.env.VUE_APP_BACKEND_URL || '/api'
      window.location.href = `${backendUrl}/glogin/validate`
    }
  }
}
</script>
<style lang="scss" scoped>
  @use "../../assets/styles/variables.scss" as *;
</style>
